import React from "react";
import { CrewPilotModuleShell } from "../../CrewPilotModuleShell";
import { PAGE_LAYOUT } from "../../../layout/pageLayout";
import { DesktopKpiStrip } from "../../shared/DesktopKpiStrip";
import { DeskPanel, DeskRowMenu } from "../../desktop/DeskTable";
import { formatCurrency } from "../../../helpers/estimateTotals";
import { DeskLine } from "./EstimateSummaryDesktop";
import "./estimateDesktop.css";

/**
 * Desktop Feature workspace: measurements, materials and labour as sibling
 * panels with a pricing side panel. The section nodes are the existing
 * (shared) section components, scoped by the `.est-desk` wrapper class.
 */
export function FeatureWorkspaceDesktop({
  title,
  parentLabel,
  error,
  netSqft,
  featureTotal,
  materialsTotal,
  labourTotal,
  surfaceTotals,
  menuItems,
  onBack,
  assemblyNode,
  measurementsNode,
  materialsNode,
  labourNode,
  children,
}) {
  const items = (menuItems || []).filter(Boolean);

  return (
    <CrewPilotModuleShell
      title={title}
      onBack={onBack}
      desktopBackLabel={parentLabel || "Location"}
      layout={PAGE_LAYOUT.COMMAND}
      compact
      headerActions={
        items.length > 0 ? (
          <div className="cdh-actions">
            <DeskRowMenu
              label="Feature actions"
              items={items.map((item, index) => ({ ...item, key: `m${index}`, danger: item.destructive }))}
              onSelect={(item) => {
                if (!item.disabled) item.onClick?.();
              }}
            />
          </div>
        ) : null
      }
    >
      {error ? <div className="est-inline-error">{error}</div> : null}

      <DesktopKpiStrip
        ariaLabel="Feature totals"
        className="est-d-kpi4"
        tiles={[
          { key: "total", value: formatCurrency(featureTotal), label: "Feature Total", tone: "gold" },
          { key: "mat", value: formatCurrency(materialsTotal), label: "Materials", tone: "blue" },
          { key: "lab", value: formatCurrency(labourTotal), label: "Labour", tone: "muted" },
          { key: "area", value: `${netSqft.toFixed(0)} ft²`, label: "Net Area", tone: "green" },
        ]}
      />

      <div className="dp-grid dp-grid--main-side est-desk">
        <div className="est-d-stack">
          {measurementsNode}
          <div className="est-d-grid-2">
            {materialsNode}
            {labourNode}
          </div>
        </div>

        <aside className="est-d-side" aria-label="Feature summary">
          <DeskPanel title="Summary">
            <DeskLine label="Materials" value={materialsTotal} />
            <DeskLine label="Labour" value={labourTotal} />
            <DeskLine label="Feature Total" value={featureTotal} emphasis />
            {surfaceTotals.length > 0 ? (
              <>
                <hr className="est-d-hr" />
                <p className="est-d-subhead">Surface Area</p>
                {surfaceTotals.map((row) => (
                  <div key={row.surfaceType} className="est-d-line">
                    <span>{row.label}</span>
                    <span>{row.sqft.toFixed(1)} ft²</span>
                  </div>
                ))}
              </>
            ) : null}
          </DeskPanel>
          {assemblyNode ? <DeskPanel title="Assembly">{assemblyNode}</DeskPanel> : null}
        </aside>
      </div>
      {children}
    </CrewPilotModuleShell>
  );
}
